import React from "react";

const date2string = ( d ) => {
	if ( typeof d === 'string' ) {
		d = d.toLowerCase();
		if ( d === 'today' ) {
			d = 0;
		} else if ( d === 'tomorrow' ) {
			d = 1;
		} else {
			return d;
		}
	}
	if ( typeof d === 'number' ) {
		const a = new Date();
		a.setDate( a.getDate() + parseInt(d));
		d = a;
	}
	if ( d instanceof Date) {
		return [
			String(d.getFullYear()),
			String(d.getMonth()+1).padStart(2,'0'),
			String(d.getDate()).padStart(2,'0')
		].join('-');
	}
	return undefined;
};

const SelectDate = class extends React.Component {
	constructor(props ) {
		super(props);
		this.state = { value: props.value||'' };
		this.uid = "SelectDate-"+window.glob.generateUid();
		this.onchange = this.onchange.bind(this);
	}

	onchange(evt) {
		const v = evt.target.value;
		if ( this.props.globPrefix && this.props.name ) {
			window.glob.trigger(
				this.props.globPrefix+'changed',
				{ name: this.props.name, value: v }
			);
		}
		this.setState({value:v});
	};
	render() {
		return (
			<input
				type={ this.props.useTime ? "datetime-local" : "date" }
				min={ date2string(this.props.min) }
				max={ date2string(this.props.max) }
				autoFocus={this.props.autoFocus}
				required={this.props.required}
				value={this.state.value??""}
				id={this.uid}
				className={"form-control"}
				style={{width:"100%"}}
				onChange={(e)=>{ this.onchange(e)} }
			/>
		);
	}

};

export default SelectDate;